import classNames from 'classnames'
import React from 'react'
import PropTypes from 'prop-types'
import { useNavigationContext } from '../../contexts/NavigationContext.jsx'

import './styles.scss'

const ContentContainer = ({ children }) => {
  const {
    showSidebar,
    showContentContainer,
    sidebarRetracted,
    removePadding,
    removeOverflow,
  } = useNavigationContext()
  return (
    <div
      className={classNames(
        'content-container',
        { 'content-container--no-sidebar': !showSidebar },
        { 'content-container--hidden': !showContentContainer },
        { 'content-container--expanded': !sidebarRetracted },
        { 'content-container--no-overflow': removeOverflow },
        { 'remove-padding': removePadding }
      )}
    >
      {children}
    </div>
  )
}

ContentContainer.propTypes = {
  removePadding: PropTypes.bool,
}

ContentContainer.defaultProps = {
  removePadding: false,
}

export default ContentContainer
